export enum IconTypeEnum {
  /* Building */
  Home = 'home',
  Store = 'store',

  /* Business */
  Award = 'award',
  Calendar2 = 'calendar-2',
  CalendarCheck = 'calendar-check',
  CalendarDate = 'calendar-date',
  Calendar = 'calendar',
  Mail = 'mail',
  MailSend = 'mail-send',
  Printer = 'printer',

  /* Communication */
  Feedback = 'feedback',
  Message = 'message',

  /* Design */
  Edit = 'edit',
  Focus = 'focus',
  Ruler = 'ruler',

  /* Device */
  Database = 'database',
  Mac = 'mac',
  MacBook = 'macbook',
  Smartphone = 'smartphone',
  Phone = 'phone',
  ShutDown = 'shut-down',

  /* Documents */
  Bill = 'bill',
  File = 'file',

  /* Editor */
  Attachment = 'attachment',
  Link = 'link',
  Unlink = 'unlink',
  ListCheck = 'list-check',

  /* Finance */
  BankCard = 'bank-card',
  Exchange = 'exchange',
  Gift = 'gift',
  Mastercard = 'mastercard',
  MoneyCnyBox = 'money-cny-box',
  MoneyEuroBox = 'money-euro-box',
  MoneyDollarBox = 'money-dollar-box',
  MoneyPoundBox = 'money-pound-box',
  Refund = 'refund',
  SecurePayment = 'secure-payment',
  Visa = 'visa',
  ShoppingCart = 'shopping-cart',
  Return = 'return',

  /* Health and medical */
  Heart = 'heart',
  HeartPulse = 'heart-pulse',

  /* Logos */
  Amazon = 'amazon',
  Android = 'android',
  Apple = 'apple',
  Chrome = 'chrome',
  Drive = 'drive',
  Facebook = 'facebook',
  Firefox = 'firefox',
  Google = 'google',
  Ie = 'ie',
  Instagram = 'instagram',
  Messenger = 'messenger',
  Pinterest = 'pinterest',
  Safari = 'safari',
  Slack = 'slack',
  Snapchat = 'snapchat',
  Twitter = 'twitter',
  Whatsapp = 'whatsapp',
  Youtube = 'youtube',
  Telegram = 'telegram',
  Viber = 'viber',

  /* Map */
  Itinerary = 'itinerary',
  MapPin = 'map-pin',
  Suitcase = 'suitcase',
  Truck = 'truck',
  Earth = 'earth',
  Navigation = 'navigation',
  Distance = 'distance',

  /* Media */
  Camera = 'camera',
  Equalizer = 'equalizer',
  Film = 'film',
  Fullscreen = 'fullscreen',
  Image = 'image',
  Music2 = 'music-2',
  Music = 'music',
  Notification = 'notification',
  PauseCircle = 'pause-circle',
  Pause = 'pause',
  PlayCircle = 'play-circle',
  Play = 'play',
  Repeat = 'repeat',
  StopCircle = 'stop-circle',
  Stop = 'stop',
  VolumeUp = 'volume-up',
  VolumeDown = 'volume-down',
  VolumeMute = 'volume-mute',

  /* Others */
  Scales = 'scales',
  Tshirt = 't-shirt',

  /* Services */
  SelectedByDecathlon = 'selected-by-decathlon',

  /* System */
  Add = 'add',
  Alert = 'alert',
  ArrowDropDown = 'arrow-drop-down',
  ArrowDropLeft = 'arrow-drop-left',
  ArrowDropUp = 'arrow-drop-up',
  ArrowDropRight = 'arrow-drop-right',
  ArrowLeftS = 'arrow-left-s',
  ArrowDownS = 'arrow-down-s',
  ArrowRightS = 'arrow-right-s',
  ArrowUpS = 'arrow-up-s',
  ArrowLeft = 'arrow-left',
  ArrowLeftDown = 'arrow-left-down',
  ArrowDown = 'arrow-down',
  ArrowRightDown = 'arrow-right-down',
  ArrowRight = 'arrow-right',
  ArrowRightUp = 'arrow-right-up',
  ArrowUp = 'arrow-up',
  ArrowLeftUp = 'arrow-left-up',
  ArrowLeftCircle = 'arrow-left-circle',
  ArrowDownCircle = 'arrow-down-circle',
  ArrowRightCircle = 'arrow-right-circle',
  ArrowUpCircle = 'arrow-up-circle',
  ArrowLeftRight = 'arrow-left-right',
  ArrowUpDown = 'arrow-up-down',
  ThumbDown = 'thumb-down',
  CheckboxCircle = 'checkbox-circle',
  DeleteBin = 'delete-bin',
  History = 'history',
  ThumbUp = 'thumb-up',
  ErrorWarning = 'error-warning',
  Question = 'question',
  Information = 'information',
  Lock = 'lock',
  Settings = 'settings',
  More2 = 'more-2',
  More = 'more',
  CheckBoxBlankCircle = 'checkbox-blank-circle',
  RadioButton = 'radio-button',
  CheckBoxBlank = 'checkbox-blank',
  Checkbox = 'checkbox',
  Star = 'star',
  StarHalf = 'star-half',
  ListSettings = 'list-settings',
  Eye = 'eye',
  EyeOff = 'eye-off',
  Close = 'close',
  Check = 'check',
  CloseCircle = 'close-circle',
  Subtract = 'subtract',
  Search = 'search',
  ArrowGoBack = 'arrow-go-back',
  ArrowGoForward = 'arrow-go-forward',
  Package = 'package',
  Download = 'download',
  FilterOff = 'filter-off',
  CheckboxMultiple = 'checkbox-multiple',
  Upload = 'upload',
  Share = 'share',
  ShieldCheck = 'shield-check',
  Menu = 'menu',
  ExternalLink = 'external-link',
  Function = 'function',
  Filter = 'filter',
  Timer = 'timer',
  Time = 'time',
  Refresh = 'refresh',
  Counter = 'counter',

  /* Task */
  Task = 'task',

  /* Users and faces */
  Emotion = 'emotion',
  EmotionSad = 'emotion-sad',
  EmotionUnhappy = 'emotion-unhappy',
  EmotionLaugh = 'emotion-laugh',
  EmotionNormal = 'emotion-normal',
  User = 'user',
  Group = 'group',

  /* Weather */
  Fire = 'fire',
  Sun = 'sun',
  Flashlight = 'flashlight',
  Cloud = 'cloud',
  CloudWindy = 'cloud-windy',
  Hail = 'hail',
  Snowy = 'snowy',
  TempHot = 'temp-hot',
  Windy = 'windy',
  Mist = 'mist',
  Thunderstorms = 'thunderstorms',
  Moon = 'moon',
  Drizzle = 'drizzle',
  Foggy = 'foggy',
  TempCold = 'temp-cold',
  Rainy = 'rainy',
  MoonCloudy = 'moon-cloudy',
  SunCloudy = 'sun-cloudy',
  Showers = 'showers',
}
